import { ReactNode } from 'react';
import { OverlaySpinner } from '@ankr.com/ui';
import loadable from '@loadable/component';

import { featureConfig } from 'modules/common/featureConfig';

const Web3Provider = loadable(
  () => import('./Web3Provider').then(module => module.Web3Provider),
  {
    fallback: <OverlaySpinner />,
  },
);

interface IWeb3ProviderLazyProps {
  children?: ReactNode;
}

export const Web3ProviderLazy = ({ children }: IWeb3ProviderLazyProps) => {
  return featureConfig.newCryptoPayment ? (
    <Web3Provider>{children}</Web3Provider>
  ) : (
    <>{children}</>
  );
};
